var eventListeners = [];

export default class Settings {
  static get(name, defaultValue) {
    let value = localStorage.getItem(name);
    if (value === null)
      return defaultValue;

    return value;
  }

  static set(name, value) {
    localStorage.setItem(name, value);

    eventListeners.forEach(listener => {
      if (listener) {
        listener(name, value);
      }
    });
  }

  static addOnChangeListener(listener) {
    eventListeners.push(listener);
  }

  static removeOnChangeListener(listener) {
    eventListeners = eventListeners.filter(x => x != listener);
  }
}
